// Inline SVG-flagg som funker på alle OS (Windows har ikke emoji-flagg innebygd).
// Tegnet til skala 24x18 (4:3) som matcher standard flagg-proporsjon.
import React from "react";

const FLAGS = {
  no: (
    <svg viewBox="0 0 22 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="22" height="16" fill="#BA0C2F" />
      <rect x="6" width="2" height="16" fill="#FFFFFF" />
      <rect y="7" width="22" height="2" fill="#FFFFFF" />
      <rect x="6.5" width="1" height="16" fill="#00205B" />
      <rect y="7.5" width="22" height="1" fill="#00205B" />
    </svg>
  ),
  sv: (
    <svg viewBox="0 0 22 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="22" height="16" fill="#006AA7" />
      <rect x="6" width="2" height="16" fill="#FECC00" />
      <rect y="7" width="22" height="2" fill="#FECC00" />
    </svg>
  ),
  da: (
    <svg viewBox="0 0 22 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="22" height="16" fill="#C8102E" />
      <rect x="6" width="2" height="16" fill="#FFFFFF" />
      <rect y="7" width="22" height="2" fill="#FFFFFF" />
    </svg>
  ),
  en: (
    <svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <clipPath id="ukmask"><path d="M0,0 v30 h60 v-30 z" /></clipPath>
      <rect width="60" height="30" fill="#012169" />
      <g clipPath="url(#ukmask)">
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#FFFFFF" strokeWidth="6" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" clipPath="url(#ukmask)" />
        <path d="M30,0 V30 M0,15 H60" stroke="#FFFFFF" strokeWidth="10" />
        <path d="M30,0 V30 M0,15 H60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  ),
};

export default function Flag({ code, className = "" }) {
  const flag = FLAGS[code];
  if (!flag) return null;
  return (
    <span
      className={`inline-flex items-center justify-center overflow-hidden border border-white/10 ${className}`}
      style={{ width: "20px", height: "14px", lineHeight: 0 }}
      aria-label={code.toUpperCase()}
    >
      {flag}
    </span>
  );
}
